import {
	type IActiveElectionData,
	type IActiveElectionResponse,
	type IApiResponse,
	type IGetPartyByIDState,
	type IUpdateCandidate,
} from '@/helpers/types';

import { coreApiSlice } from '../apiSlice';

export const candidateApiSlice = coreApiSlice.injectEndpoints({
	endpoints: (builder) => ({
		createCandidate: builder.mutation<
			IApiResponse,
			{
				electionId: number;
				userId: number;
			}
		>({
			query: (body) => ({
				method: 'POST',
				url: '/Candidate',
				body,
			}),
		}),
		getCandidate: builder.query<IApiResponse<string>, Record<string, string> | undefined>({
			query: (params) => ({
				url: '/Candidate',
				params,
			}),
		}),
		getCandidateById: builder.query<IApiResponse, string>({
			query: (id) => ({
				method: 'POST',
				url: `/Candidate/${id}`,
			}),
		}),
		updateCandidate: builder.mutation<IApiResponse, IUpdateCandidate>({
			query: (params) => ({
				method: 'PUT',
				url: '/Candidate',
				params,
			}),
		}),
		deleteCandidate: builder.query<IApiResponse<IGetPartyByIDState>, { id: string }>({
			query: ({ id }) => ({
				method: 'DELETE',
				url: `/Candidate/delete/${id}`,
			}),
		}),
		getCandidateElection: builder.mutation<IActiveElectionResponse & { data: IActiveElectionData }, { id: string }>({
			query: ({ id }) => ({
				method: 'GET',
				url: `/Candidate/get-election/${id}`,
			}),
		}),
		getActiveElections: builder.mutation<IApiResponse<IActiveElectionData[]>, { id: string }>({
			query: ({ id }) => ({
				method: 'GET',
				url: `/Candidate/get-active-elections/${id}`,
			}),
		}),
	}),
});

export const { useCreateCandidateMutation, useGetCandidateElectionMutation, useGetActiveElectionsMutation } = candidateApiSlice;
